import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';

export interface EnumItem {
  id: number;
  nome: string;
}

@Injectable({providedIn: 'root'})
export class AdminListasService {
  private http = inject(HttpClient);
  private baseUri = environment.api.uri.concat('admin/listas');

  listar(tipo: string): Observable<EnumItem[]> {
    return this.http.get<EnumItem[]>(`${this.baseUri}/${tipo}`);
  }

  criar(tipo: string, nome: string): Observable<EnumItem> {
    return this.http.post<EnumItem>(`${this.baseUri}/${tipo}`, {nome});
  }

  criarConcessionaria(lote: string, nomeAmigavel: string): Observable<EnumItem> {
    return this.http.post<EnumItem>(`${this.baseUri}/concessionaria`, {lote, nomeAmigavel});
  }

  excluir(tipo: string, id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUri}/${tipo}/${id}`);
  }
}
